// Telt hoeveel vragen van een vragenlijst op één meetmoment gesteld worden.
//
// Voedt de cel in de meetmomententabel ('12 van 18 vragen'), de voet van de
// selectiemodal en de regel in het deelscherm — één telling, zodat die drie
// nooit uit elkaar kunnen lopen.
//
// Sectiemarkeringen (`Type: 'section'`) zijn geen vragen en tellen niet mee.
// ID's van inmiddels verwijderde vragen die nog in de uitsluitingslijst staan
// evenmin: die matchen geen bestaand veld en zijn dus onschadelijk. Een
// meetstandaardvraag telt altijd als 'aan' — die is niet uit te zetten.

import isStandardQuestion from './isStandardQuestion'

/**
 * @param {Array<object>} fields - QuestionnaireFields van één vragenlijst,
 *   inclusief de sectiemarkeringen.
 * @param {Array<string>} [excludedFieldIDs] - `MeasureMoments.ExcludedFieldIDs`.
 * @returns {{total: number, active: number}} Aantal vragen in de vragenlijst en
 *   hoeveel daarvan op dit meetmoment aanstaan.
 */
const summarizeMomentQuestions = (fields, excludedFieldIDs) => {
    if (!Array.isArray(fields)) return { total: 0, active: 0 }

    const questions = fields.filter((field) => field?.Type !== 'section')
    const excluded = new Set(excludedFieldIDs || [])

    return {
        total: questions.length,
        // Zelfde verdediging als filterFieldsForMoment: ook een uitgesloten
        // SECTIE haalt zijn vragen weg, anders meldt de tabel 18 van 18 terwijl
        // de respondent er minder krijgt.
        active: questions.filter((question) => (
            isStandardQuestion(question)
            || !(excluded.has(question?.ID) || excluded.has(question?.SectionID))
        )).length,
    }
}

export default summarizeMomentQuestions
